export default __webpack_public_path__ + "static/media/AssetTagger.157936a835dc3db15ded3521c8932560.webp";